<div class="main-container">
  <h1>{{ 'not-found.error' | translate }}</h1>
  <h2>{{ 'not-found.message' | translate }}</h2>
  <p-button
    label="{{ 'not-found.button-label' | translate }}"
    routerLink="/todo"
  ></p-button>
</div>
